import { Language } from 'apprise-core/language'
import { useEffect } from 'react'
import { useLanguage } from '../../apprise-frontend-core/intl/language'


export const LanguageObserver = (props: Partial<{

    language: Language

}>) => {

    const lang = useLanguage()
    
    const { language } = props

     useEffect(() => {

        if (language && language !== lang.current()){
            console.log("changing",language)
            lang.change(language)
}
        // eslint-disable-next-line
    }, [language])

    return null
}